import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Image from 'next/image';
import { FieldFooter } from '../FieldFooter';
import { Icon, MediaCardGroupRoot, MediaCardRoot } from './MediaCard.styles';
/**
 * MediaCardGroups contain a list of MediaCards and handle the grid alignment.
 */ export const MediaCardGroup = ({ children, desktopColumns, errorMessage, mobileColumns })=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MediaCardGroupRoot, {
                $desktopColumns: desktopColumns,
                $mobileColumns: mobileColumns,
                children: children
            }),
            Boolean(errorMessage) && /*#__PURE__*/ _jsx(FieldFooter, {
                fieldFooterLabel: errorMessage,
                fieldFooterType: 'error'
            })
        ]
    });
/**
 * MediaCards are input containers that house a media component (image or icon).
 * An input element can be passed inside the inputSlot property.
 */ export const MediaCard = ({ children, isActive, isDisabled, mediaProperties: { iconName, imageData }, ...props })=>/*#__PURE__*/ _jsxs(MediaCardRoot, {
        ...props,
        $isActive: isActive,
        "aria-disabled": isDisabled,
        as: "label",
        children: [
            imageData && /*#__PURE__*/ _jsx(Image, {
                ...imageData
            }),
            iconName && /*#__PURE__*/ _jsx(Icon, {
                name: iconName
            }),
            children
        ]
    });

//# sourceMappingURL=MediaCard.js.map